import React from 'react'
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { appGlobal } from '../api/appGlobal';
import { getOcr } from '../api/getOcr';
import ValidateContext from '../context/context'
import Steps from "./Steps";
import "./styles.css";
import incode from "./incode";

//renderizamos tutorial del reverso de la Id
function TutorialFrontId({ token, onSuccess }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderFrontTutorial(containerRef.current, {
      onSuccess,
      noWait: true
    });
    isMounted.current = true;
  }, [onSuccess]);

  return <div ref={containerRef}></div>;
}

//renderizamos camara para captura el reverso de la Id
function FrontId({ session, onSuccess, showError }) {

  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderCamera("front", containerRef.current, {
      onSuccess,
      onError: showError,
      token: session,
      numberOfTries: -1
    });
    isMounted.current = true;
  }, [onSuccess, showError, session]);

  return <div ref={containerRef}></div>;
}

//renderizamos camara para captura el anverso de la Id
function BackId({ session, onSuccess, showError }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderCamera("back", containerRef.current, {
      onSuccess,
      onError: showError,
      token: session,
      numberOfTries: -1
    });
    isMounted.current = true;
  }, [onSuccess, showError, session]);

  return <div ref={containerRef}></div>;
}

//procesamos las capturas de la Id
function ProcessId({ session, onSuccess }) {

  //console.log(phone);
  incode.addPhone({ token: session.token }).then(res => res)
  incode.addCustomFields({ token: session.token })

  useEffect(() => {
    incode.processId({ token: session.token }).then(() => {
      onSuccess();
    });
  }, [onSuccess, session]);

  return <p>Processing...</p>;
}

//renderizamos la camara para capturar la selfie
function Selfie({ session, onSuccess, showError }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderCamera("selfie", containerRef.current, {
      onSuccess,
      onError: showError,
      token: session,
      numberOfTries: 3
    });
    isMounted.current = true;
  }, [onSuccess, showError, session]);

  return <div ref={containerRef}></div>;
}

//finalizamos sesion de incode y vamos a la panta lla de verifaIdentificacion... si todo sale bien



function FinishSession({ session, navigate, rutaContinue, typeCredential}) {
  
  const containerRef = useRef();

  let flowId=appGlobal.configurationId;
  let token=session.token;

  useEffect(()=>{

    incode.getFinishStatus(flowId, { token });

    if(typeCredential=="ine"){
      localStorage.setItem("interviewIdINE", session.interviewId);
      localStorage.setItem("tokenIncodeINE", session.token);
    }else if(typeCredential=="lic"){ 
      localStorage.setItem("interviewIdLic", session.interviewId);
      localStorage.setItem("tokenIncodeLic", session.token);
    }
   
    navigate(rutaContinue);

  })
  return <div ref={containerRef}></div>;
}


//Renderizamos conferencia
function Conference({ session, onSuccess, showError }) {
  const [status, setStatus] = useState();
  const containerRef = useRef();

  useEffect(() => {
    incode.renderConference(
      containerRef.current,
      {
        token: session
      },
      {
        onSuccess: (status) => {
          setStatus(status);
        },
        onError: (error) => {
          console.log("error", error);
          setStatus(error);
        },
        onLog: (...params) => console.log("onLog", ...params)
      }
    );
  }, [onSuccess, showError, session]);

  if (status) {
    return <p>Finished with status {status}</p>;
  }

  return <div ref={containerRef}></div>;
}

export default function AppIncode() {

  const location = useLocation();
  const rutaContinue = location.state.rutaContinue;
  const typeCredential = location.state.typeCredential;

  //iniciar estados
  const [session, setSession] = useState();
  const [step, setStep] = useState(1);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  //consumimos el contexto
  const { flujoActual, setFlujoActual } = useContext(ValidateContext);

  //creamos una sesion de incode con un flujo de cliente
  useEffect(() => {
    let flowId = appGlobal.configurationId;
    incode.createSession("ALL", undefined, {
      configurationId: flowId,
    }).then(async (session) => {
      localStorage.setItem("interviewID", session.interviewId)
      setSession(session);
    });
  }, []);

  function goNext() {
    setStep(step + 1);
  }

  function showError() {
    setError(true);
  }

  window.addEventListener('popstate', function (e) {
    var state = e.state;
    if (state !== null) {
      //load content with ajax
      stopCamera();
      console.log("camara detenida =>");
    }
    else {
      console.log(state);
    }
  });

  function stopCamera() {
    //history.go();
  }

  function showExitos() {

    let flowId = appGlobal.configurationId;
    let toke = session.token;

    incode.getFinishStatus(flowId, { toke });

    navigate('/PantallaBase');

  }

  if (!session) return "loading";

  if (error) return "Error!";

  //componentes de incode, se les pasa la session como props
  return (
    <>
      <link
        rel="stylesheet"
        href="https://sdk-js.s3.amazonaws.com/sdk/styles-1.6.4.css"
      />
      <Steps currentStep={step}>
        <TutorialFrontId onSuccess={goNext} />
        <FrontId session={session} onSuccess={goNext} showError={showError} />
        <BackId session={session} onSuccess={goNext} showError={showError} />
        <ProcessId session={session} onSuccess={goNext} showError={showError} />
        <Selfie session={session} onSuccess={goNext} showError={showError} />
        <FinishSession session={session} navigate={navigate} rutaContinue={rutaContinue}  typeCredential={typeCredential} />
      </Steps>
    </>
  );
}
